import {createReducer, on} from '@ngrx/store';
import {EActionStatus} from 'src/app/shared/enums/action-status.enum';
import {ISignUpState} from '../models/sign-up-state.model';
import {
  getCaptchaResponseSuccess,
  getRecaptchaTokenSuccess,
  loadCities,
  loadCitiesSuccess,
  loadCountries,
  loadCountriesSuccess,
  loadMedicalSpecialties,
  loadMedicalSpecialtiesSuccess,
  loadRegions,
  loadRegionsSuccess,
  resendLink,
  resendLinkFailure,
  resendLinkSuccess,
  resetCaptchaFromSignupEffects,
  resetCaptchaFromSignupRequestComponent,
  resetCities,
  signUpFailure,
  signUpRequest,
  signUpSuccess,
} from './sign-up.actions';

const initialSignUpState: ISignUpState = {
  status: {
    countryStatus: EActionStatus.Initial,
    regionStatus: EActionStatus.Initial,
    cityStatus: EActionStatus.Initial,
    medicalSpecialtiesStatus: EActionStatus.Initial,
    accountRequestStatus: EActionStatus.Initial,
    resendLinkStatus: EActionStatus.Initial,
  },
  countries: [],
  regions: [],
  cities: [],
  medicalSpecialties: [],
  accountSuccessResponse: null,
  accountFailureResponse: '',
  recaptchaToken: '',
  captchaResponse: false,
};

export const signUpReducer = createReducer(
  initialSignUpState,
  on(loadCountries, state => ({
    ...state,
    status: {...state.status, countryStatus: EActionStatus.Pending},
  })),
  on(loadCountriesSuccess, (state, {countries}) => ({
    ...state,
    status: {...state.status, countryStatus: EActionStatus.Success},
    countries: countries,
  })),
  on(loadRegions, state => ({
    ...state,
    status: {...state.status, regionStatus: EActionStatus.Pending},
  })),
  on(loadRegionsSuccess, (state, {regions}) => ({
    ...state,
    status: {...state.status, regionStatus: EActionStatus.Success},
    regions: regions,
  })),
  on(loadCities, state => ({
    ...state,
    status: {...state.status, cityStatus: EActionStatus.Pending},
  })),
  on(loadCitiesSuccess, (state, {cities}) => ({
    ...state,
    status: {...state.status, cityStatus: EActionStatus.Success},
    cities: cities,
  })),
  on(resetCities, state => ({
    ...state,
    status: {...state.status, cityStatus: EActionStatus.Initial},
    cities: [],
  })),
  on(loadMedicalSpecialties, state => ({
    ...state,
    status: {
      ...state.status,
      medicalSpecialtiesStatus: EActionStatus.Pending,
    },
  })),
  on(loadMedicalSpecialtiesSuccess, (state, {medicalSpecialties}) => ({
    ...state,
    status: {
      ...state.status,
      medicalSpecialtiesStatus: EActionStatus.Success,
    },
    medicalSpecialties: medicalSpecialties,
  })),
  on(signUpRequest, state => ({
    ...state,
    status: {...state.status, accountRequestStatus: EActionStatus.Pending},
  })),
  on(signUpSuccess, state => ({
    ...state,
    status: {...state.status, accountRequestStatus: EActionStatus.Success},
  })),
  on(signUpFailure, (state, {reason}) => ({
    ...state,
    status: {...state.status, accountRequestStatus: EActionStatus.Failure},
    accountFailureResponse: reason,
  })),

  on(getRecaptchaTokenSuccess, (state, {recaptchaToken}) => ({
    ...state,
    recaptchaToken: recaptchaToken,
  })),
  on(getCaptchaResponseSuccess, (state, {captchaResponse}) => ({
    ...state,
    captchaResponse: captchaResponse,
  })),
  on(resetCaptchaFromSignupEffects, resetCaptchaFromSignupRequestComponent, state => ({
    ...state,
    captchaResponse: false,
    recaptchaToken: '',
  })),
  on(resendLink, state => ({
    ...state,
    status: {...state.status, resendLinkStatus: EActionStatus.Pending},
  })),
  on(resendLinkSuccess, state => ({
    ...state,
    status: {...state.status, resendLinkStatus: EActionStatus.Success},
  })),
  on(resendLinkFailure, state => ({
    ...state,
    status: {...state.status, resendLinkStatus: EActionStatus.Failure},
  }))
);
